<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div class="mb-5 w-100" v-show="!loading">
                    <button class="btn btn-primary float-right" @click="addNewCampaign" id="btnAddCampaign">
                        Add Campaign
                    </button>
                </div>
                <div v-show="!loading">
                    <data-table :headings="campaignsHeadings" :data="campaigns" :hasActions="true"
                                :hasNoFilter="false"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @filterSearchClicked="onFilterSearchClicked"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onCampaignActionClicked">
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">
                                            <i class="fas fa-search"></i>
                                        </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Participating Sites</label>
                                        <bootstrap-select  :selectOptions="sites" :selectedOption="filter.siteId" :elementId="'siteFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onSiteFilterSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="pr-3 float-right">
                                            <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                                           :componentId="'campaignFilterRadioButtons'"
                                                                           @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <add-or-update-campaign-modal
        :heading="addOrUpdateCampaignModal.heading"
        :modalId="addOrUpdateCampaignModal.modalId"
        :show-modal="addOrUpdateCampaignModal.showModal"
        :campaign="addOrUpdateCampaignModal.campaignToEdit"
        @okClicked="closeAddOrUpdateCampaignModal"></add-or-update-campaign-modal>

    <mark-as-active-inactive-modal
            :heading="campaignMarkAsActiveInactiveModal.heading"
            :modalId="campaignMarkAsActiveInactiveModal.modalId"
            :isSaving="campaignMarkAsActiveInactiveModal.isSaving"
            :showModal="campaignMarkAsActiveInactiveModal.showModal"
            :isActive="campaignMarkAsActiveInactiveModal.isActive"
            @closeClicked="campaignMarkAsActiveInactiveModal.showModal = false"
            @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>

    <div class="modal fade" :id="campaignLinkModal.modalId" tabindex="-1" role="dialog" :aria-labelledby="campaignLinkModal.modalId + 'Label'" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="campaignLinkModal.modalId + 'Label'">Campaign Link - {{campaignLinkModal.name}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onModalCloseClick">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{campaignLinkModal.campaignLink}}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>
                </div>
            </div>
        </div>
    </div>
    
    <draw-winner-modal
            :heading="drawWinnerModal.heading"
            :modalId="drawWinnerModal.modalId"
            :show-modal="drawWinnerModal.showModal"
            :campaignId="drawWinnerModal.campaignId"
            @okClicked="closeDrawWinnerModal"
            @winningSubmissionSelected="onWinningSubmissionSelected"></draw-winner-modal>
    
    <view-submission-modal
            :heading="viewSubmissionModal.heading"
            :modalId="viewSubmissionModal.modalId"
            :showModal="viewSubmissionModal.showModal"
            :campaignSubmission="viewSubmissionModal.submission"
            :submissionIsDrawnWinner="viewSubmissionModal.submissionIsDrawnWinner"
            @okClicked="onViewSubmissionModalClose"
            @drawnWinnerRejectedRedraw="onDrawnWinnerRejectedRedraw"></view-submission-modal>

</div>
